import React, { useState } from 'react';
import {
  getDocs, query, collection, where, doc, setDoc, increment, updateDoc, getDoc
} from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useTranslation } from 'react-i18next';

const RetailRecordForm = ({ customerId, retailOffers, onRecorded, setOfferData }) => {
  const [offerId, setOfferId] = useState('');
  const [amount, setAmount] = useState('');
  const [pin, setPin] = useState('');
  const { t } = useTranslation();

  const verifyPin = async (pin) => {
    const snap = await getDocs(query(collection(db, 'admin_users'), where('pin', '==', pin)));
    return !snap.empty;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!(await verifyPin(pin))) {
      alert(t('invalid_admin_pin'));
      return;
    }

    const ref = doc(db, 'customer_offers', `${customerId}_${offerId}`);
    await setDoc(ref, {
      customer_id: customerId,
      offer_id: offerId,
      retail_spent: increment(Number(amount)),
      claimed_discounts: increment(0)
    }, { merge: true });

    try {
      const customerRef = doc(db, 'customers', customerId);
      const customerSnap = await getDoc(customerRef);

      if (customerSnap.exists()) {
        const allOffersSnap = await getDocs(query(
          collection(db, 'customer_offers'),
          where('customer_id', '==', customerId)
        ));

        let newTotalPoints = 0;

        allOffersSnap.forEach(doc => {
          const data = doc.data();
          if (data.num_items) newTotalPoints += data.num_items;
          if (data.retail_spent) newTotalPoints += Math.floor(data.retail_spent / 10);
        });

        await updateDoc(customerRef, {
          total_points: newTotalPoints
        });
        console.log("🔥 Firestore total_points saved:", newTotalPoints);

        // ✅ Update local state
        if (setOfferData) {
          setOfferData(prev => {
            const current = prev[offerId] || { retail_spent: 0, claimed_discounts: 0 };
            return {
              ...prev,
              [offerId]: {
                ...current,
                retail_spent: (current.retail_spent || 0) + Number(amount),
              }
            };
          });
        }

        // ✅ Notify parent to update UI
        console.log("✅ Triggering UI update with:", newTotalPoints);
        onRecorded?.(newTotalPoints);
      }
    } catch (err) {
      console.error("🔥 Error updating total_points or calling onRecorded:", err);
    }

    // Clear form
    setOfferId('');
    setAmount('');
    setPin('');
  };

  return (
    <form onSubmit={handleSubmit} className="form-section">
      <h2>{t('retail.record_purchase')}</h2>
      <select value={offerId} onChange={e => setOfferId(e.target.value)} required>
        <option value="">{t('select_offer')}</option>
        {retailOffers.map(o => (
          <option key={o.id} value={o.id}>{o.title}</option>
        ))}
      </select>
      <input
        type="number"
        placeholder={t('retail.amount_spent')}
        value={amount}
        onChange={e => setAmount(e.target.value)}
        required
      />
      <input
        type="password"
        placeholder={t('admin_pin')}
        value={pin}
        onChange={e => setPin(e.target.value)}
        required
      />
      <button type="submit">{t('submit_purchase')}</button>
    </form>
  );
};

export default RetailRecordForm;